const getReferralListState = (state) => state && state.referralList ? state.referralList : {};

export const referralList = (state) => getReferralListState(state).referrals;
export const errorMessage = (state) => getReferralListState(state).errorMessage;
export const isLoading = (state) => getReferralListState(state).isLoading;
export const referralDetails = (state) => getReferralListState(state).referralDetails;
export const detailsLoading = (state) => getReferralListState(state).detailsLoading;
export const detailsError = (state) => getReferralListState(state).detailsError;
export const selectedReferralId = (state) => getReferralListState(state).selectedReferralId;
export const referralContent = (state) => getReferralListState(state).referralContent;
export const contentLoading = (state) => getReferralListState(state).contentLoading;
export const contentError = (state) => getReferralListState(state).contentError;
export const detailsDialogOpen = (state) => getReferralListState(state).detailsDialogOpen;
export const currentPage = (state) => getReferralListState(state).currentPage;
export const totalPages = (state) => getReferralListState(state).totalPages;
export const totalElements = (state) => getReferralListState(state).totalElements;